export const productDataTops = [
    {
      id: "1Musculosatejida",
      imageurl:
      'https://http2.mlstatic.com/D_NQ_NP_977246-MLA48930760191_012022-W.webp',
      name: "Musculosa tejida",
      price: "1900",
      description: "Top",
      color: "black",
      IsTalla: "Talla",
      IsSale: "Sale",
      signo: "$",
      pricebefore: "2500",
      colorbc: "pink",
      tallas: [ 1,2,3 ], 
      quantity: 1,
      isAddedFromCartButton: false
    },
    {
      id: "2Musculosacuelloalto",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_776664-MLA52841947038_122022-W.webp",
      name: "Musculosa cuello alto",
      price: "2500",
      description: "Top",
      color: "white",      
      IsTalla: "Talla",
      IsSale: "Nuevo",
      colorbc: "pink",
      tallas: [ 1,2,3,4 ],
      quantity: 1,      
      isAddedFromCartButton: false
    },
    {
      id: "3Topnudodelantero",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_694696-MLA53116022414_012023-W.webp",
      name: "Top nudo delantero",
      price: "4900",
      description: "Top",
      color: "white",      
      IsTalla: "Talla",
      tallas: [ 1,2,3 ],   
      quantity: 1,       
      isAddedFromCartButton: false  
    },
    
    {
      id: "4Topcorset",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_880630-MLA52221388211_102022-W.webp",
      name: "Top corset",
      price: "5300",
      description: "Top",
      color: "black",      
      IsTalla: "Talla",
      tallas: [ 1,2, 3 ],
      quantity: 1,
    },
    {
      id:  "5Topestampado",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_634549-MLA53443717893_012023-W.webp",
      name: "Top estampado",
      price: "3800",
      description: "Top",
      color: "white",      
      IsTalla: "Talla",
      tallas: [ 2, 3, 4 , 5],
      quantity: 1,
    },
    {
      id: "6Tophombrodescubierto",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_613074-MLA53604012962_022023-W.webp",
      name: "Top hombro descubierto",
      price: "2800",
      description: "Top",
      color: "yellow",       
      IsTalla: "Talla",
      tallas: [ 1,2 ],
      quantity: 1,
    },
    {
      id: "7Remeraconfrunce",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_803503-MLA53621405922_022023-W.webp",
      name: "Remera con frunce",
      price: "2800",
      description: "Top",
      color: 'black',
      tallas: [1,2,3,4],
      quantity: 1,
    },
    {
      id: "8Remerarayada",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_940961-MLA51165027225_082022-W.webp",
      name: "Remera rayada",
      price: "3000",
      description: "Top",
      color: "blue",
      IsTalla: "Talla",
      tallas: [ 4,5 ],
      quantity: 1,
    },
    {
      id: "9SueterRayas",
      imageurl:
        "https://res.cloudinary.com/dvjmjujc0/image/upload/v1692989228/samples/outdoor-woman.jpg",
      name: "Sueter de Rayas",
      price: "7300",
      description: "Top",
      color: "brown",
      IsTalla: "Talla",
      tallas: [ 3,4,5 ],
      quantity: 1,
    },
    {
      id: "10Topmangacorta",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_731518-MLA52512367483_112022-W.webp",
      name: "Top manga corta",
      price: "7300",
      description: "Top",
      color: "nute",
      IsTalla: "Talla",
      tallas: [ 1,2,3,4,5 ],
      quantity: 1,
    },
    {
      id: "11Topestilotrianguloretro",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_603783-MLA53092564040_122022-W.webp",
      name: "Top estilo triangulo retro",
      price: "3500",
      description: "Top",
      color: "orange",
      IsTalla: "Talla",
      tallas: [ 1,2 ],
      quantity: 1,
    },
    {
      id: "12Remerascortadealgodon",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_776401-MLA53686471246_022023-W.webp",
      name: "Remera corta de algodon",
      price: "2500",
      description: "Top",
      color: "pink",
      IsTalla: "Talla",
      tallas: [ 1,2,3,4,5 ],
      quantity: 1,
    },
    {
      id: "13Remeramusculosa",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_706152-MLA51167066192_082022-O.webp",
      name: "Remera musculosa",
      price: "2500",
      description: "Top",
      color: "green",
      IsTalla: "Talla",
      tallas: [ 1,2,3,4,5 ],
      quantity: 1,
    },
    {
      id: "14Topstrapless",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_832720-MLA31116130379_062019-W.webp",
      name: "Top strapless",
      price: "2600",
      description: "Top",
      color: "red",
      IsTalla: "Talla",
      tallas: [ 1,2,3 ],
      quantity: 1,
    },
    {
      id:"15Corsetbengalina",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_851423-MLA52700826426_122022-O.webp",
      name: "Corset bengalina",
      price: "3500",
      description: "Top",
      color: "fucsia",
      IsTalla: "Talla",
      tallas: [ 1,2,3,4 ],
      quantity: 1,
    },
    {
      id: "16Topdetiras",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_847812-MLA51807151456_102022-W.webp",
      name: "Top de tiras",
      price: "2700",
      description: "Top",
      color: "red",
      IsTalla: "Talla",
      tallas: [ 1,2,3 ],
      quantity: 1,
    },
  ];